'use strict';

require('./CompanyAddressBookService.js');

function CompanyAddressBookCtrl(
  $scope,
  $stateParams,
  contacts,
  growl,
  translations,
  CompanyAddressBookService
) {
  $scope.contacts = contacts;

  $scope.addContact = function() {
    $scope.newContact = {
      "contactName":      "",
      "contactEmail":     "",
      "contactPhone":     "",
      "contactWeb":      ""
    };

    $scope.contacts.unshift($scope.newContact);
  };

  $scope.saveContact = function(contact) {
    if (contact.id) {
      CompanyAddressBookService.update({companyId: $stateParams.companyId, contactId: contact.id}, contact);
      growl.addSuccessMessage(translations['address-book.update-successful']);
    } else {
      CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function(resp) {
        $scope.newContact = null;
        contact.id = resp.id;
        growl.addSuccessMessage(translations['address-book.insert-successful']);
      });
    }
  };

  $scope.removeContact = function(contact) {
    if (contact.id) {
      CompanyAddressBookService.delete({companyId: $stateParams.companyId, contactId: contact.id}).$promise.then(function() {
        $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
        growl.addSuccessMessage(translations['address-book.delete-successful']);
      });
    } else {
      $scope.newContact = null;
      $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
    }
  };
}

CompanyAddressBookCtrl.resolve = {
  contacts: ['CompanyAddressBookService', '$stateParams', function(CompanyAddressBookService, $stateParams) {
    return CompanyAddressBookService.query({companyId: $stateParams.companyId, all: true}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'address-book.insert-successful',
      'address-book.update-successful',
      'address-book.delete-successful'
    ]);
  }]
};

module.exports = CompanyAddressBookCtrl;

angular.module('dokiv')
  .controller('CompanyAddressBookCtrl', [
    '$scope',
    '$stateParams',
    'contacts',
    'growl',
    'translations',
    'CompanyAddressBookService',
    CompanyAddressBookCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyAddressBookCtrl.js
// module id = 308
// module chunks = 0